module.exports = __webpack_public_path__ + "static/img/about3.1.e1a7bcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about3.1.png
// module id = hp3P
// module chunks = 1